@let user = userInfos();
<div
  *ngIf="displaycurrentbreakpoint"
  class="flex items-center m-2 fixed top-0 right-0 border border-gray-400 rounded p-2 bg-gray-300 text-pink-600 text-sm"
>
  <svg
    class="h-6 w-auto inline"
    viewBox="0 0 80 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="url(#paint0_linear)"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 16C24.8 16 20.3 19.6 18.5 26.8C21.2 23.2 24.35 21.85 27.95 22.75C30.004 23.2635 31.4721 24.7536 33.0971 26.4031C35.7443 29.0901 38.8081 32.2 45.5 32.2C52.7 32.2 57.2 28.6 59 21.4C56.3 25 53.15 26.35 49.55 25.45C47.496 24.9365 46.0279 23.4464 44.4029 21.7969C41.7557 19.1099 38.6919 16 32 16ZM18.5 32.2C11.3 32.2 6.8 35.8 5 43C7.7 39.4 10.85 38.05 14.45 38.95C16.504 39.4635 17.9721 40.9536 19.5971 42.6031C22.2443 45.2901 25.3081 48.4 32 48.4C39.2 48.4 43.7 44.8 45.5 37.6C42.8 41.2 39.65 42.55 36.05 41.65C33.996 41.1365 32.5279 39.6464 30.9029 37.9969C28.2557 35.3099 25.1919 32.2 18.5 32.2Z"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="3.5"
        y1="16"
        x2="59"
        y2="48"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2298BD"></stop>
        <stop offset="1" stop-color="#0ED7B5"></stop>
      </linearGradient>
    </defs>
  </svg>
  Current breakpoint
  <span class="ml-1 sm:hidden md:hidden lg:hidden xl:hidden"
    >default (&lt; 640px)</span
  >
  <span class="ml-1 hidden sm:inline md:hidden font-extrabold">sm</span>
  <span class="ml-1 hidden md:inline lg:hidden font-extrabold">md</span>
  <span class="ml-1 hidden lg:inline xl:hidden font-extrabold">lg</span>
  <span class="ml-1 hidden xl:inline font-extrabold">xl</span>
</div>

<div class="layout-topbar">
  <div class="topbar-menu-container">
    <div class="left-column">
      <button
        #menubutton
        class="topbar-menubutton p-link"
        type="button"
        (click)="onMenuButtonClick()"
      >
        <span></span>
      </button>
    </div>

    <div class="center-column">
      <a class="app-logo" routerLink="/">
        <img alt="app logo" [src]="logo" />
      </a>
      <span class="app-name ml-2">{{ "application_name" | translate }}</span>
    </div>

    <div class="right-column">
      <div
        class="topbar-bell"
        [ngClass]="{ 'topbar-bell-active': searchActive }"
      >
        <button class="topbar-bellbutton p-link" type="button">
          <i class="pi pi-bell"></i>
        </button>
      </div>

      <div class="topbar-profile">
        <button
          *ngIf="isMobileLayout"
          class="flex items-center justify-center w-10 h-10 rounded-full bg-primary text-white font-bold"
          pStyleClass="@next"
          enterClass="hidden"
          enterActiveClass="animate-scalein"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true"
        >
          {{ getUserInitials() }}
        </button>

        <button
          *ngIf="!isMobileLayout"
          class="topbar-profile-button p-link"
          type="button"
          pStyleClass="@next"
          enterClass="hidden"
          enterActiveClass="animate-scalein"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true"
        >
          <span class="profile-details">
            @if (isLoading()) { Chargement } @else if (user) {
            <span class="profile-name">{{ user.nom }} {{ user.prenom }}</span>
            <span class="profile-job">{{ user.entrepriseNom }}</span>
            }
          </span>
          <i class="pi pi-angle-down"></i>
        </button>

        <ul
          class="list-none p-4 m-0 rounded-border shadow hidden absolute bg-surface-0 dark:bg-surface-900 origin-top w-48 right-0 top-auto z-50"
        >
          <li>
            <a
              [routerLink]="['/app/mysettings']"
              pRipple
              class="flex p-2 rounded-border items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
            >
              <i class="pi pi-cog mr-4"></i>
              <span>{{ ROUTES.myprofile.label }}</span>
            </a>
            <a
              (click)="logout()"
              pRipple
              class="flex p-2 rounded-border items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
            >
              <i class="pi pi-power-off mr-4"></i>
              <span>Déconnexion</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
